import moment from "moment";
import { formatCurrency, newCommonFormatCurrency } from "../services/mathServices";
import { getUserDisplayName } from "../user/userServices";

export const emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function documentDefaultMailer(
    totalBalance,
    toClients,
    reminder,
    listDocuments,
    user,
    displayBudgetInsightURL = false,
    company,
    reminderType = 0
) {
    const mail = company.invoiceData?.mail ? company.invoiceData.mail : null;

    return {
        mailType: documentMailType(toClients, reminder),
        defaultSubject: mail
            ? documentFormatSubject(
                  totalBalance,
                  toClients,
                  reminder,
                  reminderType,
                  listDocuments,
                  user,
                  company,
                  mail
              )
            : documentDefaultSubject(toClients, reminder, listDocuments),
        defaultText: mail
            ? documentFormatText(
                  totalBalance,
                  toClients,
                  reminder,
                  reminderType,
                  listDocuments,
                  company,
                  user,
                  mail
              )
            : documentDefaultText(
                  totalBalance,
                  toClients,
                  reminder,
                  reminderType,
                  listDocuments,
                  displayBudgetInsightURL
              ) + defaultSignature(user, company),
        withAttachment: reminder || listDocuments[0].object.type === "" ? false : true,
    };
}

export function invoiceDefaultMailer(invoice, user, thirdPartyCompany, company) {
    const baseFieldName = formatInvoiceBaseFieldName(invoice.type, invoice.depositOfId);
    return {
        mailType: "SENT_INVOICE",
        defaultSubject: company.invoiceData?.mail?.[baseFieldName]?.header
            ? invoiceFormatedSubject(invoice, user, thirdPartyCompany, company)
            : invoiceDefaultSubject(invoice),
        defaultText: company.invoiceData?.mail?.[baseFieldName]?.body
            ? invoiceFormatedText(invoice, user, thirdPartyCompany, company)
            : invoiceDefaultText(invoice) + defaultSignature(user, company),
        withAttachment: true,
    };
}

//* --- all ---
// function mailType() {}

function defaultSignature(user, company) {
    const fullName = getUserDisplayName(user);
    const companyName = company?.name || "";

    let signature = "";

    if (fullName) {
        signature += "<p><strong>" + fullName + "</strong></p>";
    }

    if (companyName) {
        signature += "<p><em>" + companyName + "</em></p>";
    }

    return signature;
}

//* --- documents ---

function formatDocumentText(document, price, user, company, text) {
    const title = document.invoiceNumber ? document.invoiceNumber : document.wording;

    text = text.replaceAll("$TITLE", title);
    text = text.replaceAll("$NUMBER", document.invoiceNumber ? document.invoiceNumber : "");
    text = text.replaceAll("$PRICE", newCommonFormatCurrency(price));
    text = text.replaceAll("$INVOICE_DATE", moment(document.date).format("DD/MM/YYYY"));
    text = text.replaceAll("$INVOICE_DUE_DATE", moment(document.dueDate).format("DD/MM/YYYY"));
    text = text.replaceAll("$INVOICE_NEXT_DUE_DATE", moment().add(1, "M").format("DD/MM/YYYY"));
    text = text.replaceAll("$IBAN", user.iban ? user.iban : "");
    text = text.replaceAll("$USER_NAME", user.firstname + " " + user.lastname);
    text = text.replaceAll("$COMPANY_NAME", company.name ? company.name : "");
    text = text.replaceAll(
        "$CLIENT_COMPANY_NAME",
        document.thirdPartyCompanyName ? document.thirdPartyCompanyName : ""
    );
    text = text.replaceAll("$RECEIVER_NAME", "");
    text = text.replaceAll("\n", "</p>\n<p>");
    return text;
}

function documentFormatSubject(
    totalBalance,
    toClients,
    reminder,
    reminderType,
    listDocuments,
    user,
    company,
    mail
) {
    if (toClients) {
        if (!reminder) {
            return formatDocumentText(
                listDocuments[0],
                totalBalance,
                user,
                company,
                mail.invoice.header
            );
        } else if (listDocuments?.length === 1) {
            if (reminderType == 1) {
                return formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.reminder1.header
                );
            } else if (reminderType == 2) {
                return formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.reminder2.header
                );
            } else if (reminderType == 3) {
                return formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.reminder3.header
                );
            }
        } else {
            return formatDocumentText(
                listDocuments[0],
                totalBalance,
                user,
                company,
                mail.multipleReminder.header
            );
        }
    } else {
        return formatDocumentText(listDocuments[0], totalBalance, user, company, mail.delay.header);
    }
}

function documentDefaultSubject(toClients, reminder, listDocuments) {
    if (toClients) {
        if (!reminder) {
            const title = listDocuments[0].invoiceNumber
                ? listDocuments[0].invoiceNumber
                : listDocuments[0].wording;
            return "Votre facture " + title;
        }
        return "Relance facture(s) en attente de règlement"; // + this.invoice.title
    }
    return "Demande de délai de règlement";
    // return 'Votre facture n° ' + this.invoice...
}

function documentFormatText(
    totalBalance,
    toClients,
    reminder,
    reminderType,
    listDocuments,
    company,
    user,
    mail
) {
    if (toClients) {
        if (listDocuments.length === 1 && (!reminder || reminderType)) {
            if (!reminder) {
                const body = formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.invoice.body
                );
                const signature = formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.signature
                );
                return body + "</p>\n<p>" + signature + "</p>";
            } else {
                let body;
                if (reminderType == 1) {
                    body = formatDocumentText(
                        listDocuments[0],
                        totalBalance,
                        user,
                        company,
                        mail.reminder1.body
                    );
                } else if (reminderType == 2) {
                    body = formatDocumentText(
                        listDocuments[0],
                        totalBalance,
                        user,
                        company,
                        mail.reminder2.body
                    );
                } else if (reminderType == 3) {
                    body = formatDocumentText(
                        listDocuments[0],
                        totalBalance,
                        user,
                        company,
                        mail.reminder3.body
                    );
                }
                const signature = formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.signature
                );
                return body + "</p>\n<p>" + signature + "</p>";
            }
        } else {
            let body = formatDocumentText(
                listDocuments[0],
                totalBalance,
                user,
                company,
                mail.multipleReminder.upperBody
            );
            for (const document of listDocuments) {
                body +=
                    "</p>\n<p>" +
                    formatDocumentText(
                        document,
                        document.amountSigned,
                        user,
                        company,
                        mail.multipleReminder.lineBody
                    );
            }
            body +=
                "</p>\n<p>" +
                formatDocumentText(
                    listDocuments[0],
                    totalBalance,
                    user,
                    company,
                    mail.multipleReminder.lowerBody
                );
            const signature = formatDocumentText(
                listDocuments[0],
                totalBalance,
                user,
                company,
                mail.signature
            );
            return body + "</p>\n<p>" + signature + "</p>";
        }
    } else {
        let body = formatDocumentText(
            listDocuments[0],
            totalBalance,
            user,
            company,
            mail.delay.upperBody
        );
        for (const document of listDocuments) {
            body +=
                "</p>\n<p>" +
                formatDocumentText(
                    document,
                    document.amountSigned,
                    user,
                    company,
                    mail.delay.lineBody
                );
        }
        body +=
            "</p>\n<p>" +
            formatDocumentText(listDocuments[0], totalBalance, user, company, mail.delay.lowerBody);
        const signature = formatDocumentText(
            listDocuments[0],
            totalBalance,
            user,
            company,
            mail.signature
        );
        return body + "</p>\n<p>" + signature + "</p>";
    }
}

function documentDefaultText(
    totalBalance,
    toClients,
    reminder,
    reminderType,
    listDocuments,
    displayBudgetInsightURL = false
) {
    if (toClients) {
        if (listDocuments.length === 1 && (!reminder || reminderType)) {
            if (!reminder) {
                const title = listDocuments[0].invoiceNumber
                    ? listDocuments[0].invoiceNumber
                    : listDocuments[0].wording;
                return (
                    "<p>Madame, Monsieur,</p>" +
                    "<p>Nous vous informons que votre facture :</p>" +
                    "<p>" +
                    title +
                    " d'un " +
                    textForAmount(
                        listDocuments[0].personalisedAmountSigned,
                        listDocuments[0].debit,
                        listDocuments[0].credit
                    ) +
                    formatDate(listDocuments[0].dueDate) +
                    ", est disponible en pièce-jointe.</p>" +
                    "<p></p>" +
                    "<p>Bien cordialement,</p>"
                );
            } else {
                if (reminderType == 1) {
                    return (
                        "<p>Madame, Monsieur,</p>\n" +
                        "<p>Après vérification de votre compte client, sauf erreur de notre part, nous n'avons pas reçu le règlement de la facture suivante :</p>" +
                        defaultMailerOPList(listDocuments) +
                        defaultPaymentText(displayBudgetInsightURL) +
                        "<p>Nous restons à votre disposition pour tout complément d’information, et vous prions d’agréer l’expression de nos salutations distinguées.</p>" +
                        "\n"
                    );
                } else if (reminderType == 2) {
                    return (
                        "<p>Madame, Monsieur,</p>\n" +
                        "<p>A ce jour et en dépit de nos précédents rappels, nous sommes au regret de constater que nous n'avons toujours pas reçu le paiement de cette facture:</p>\n" +
                        defaultMailerOPList(listDocuments) +
                        "<p>Merci de régler par virement bancaire sur le RIB figurant sur la facture le plus rapidement possible.</p>\n" +
                        "<p>Nous restons à votre disposition pour tout complément d’information, et vous prions d’agréer l’expression de nos salutations distinguées.</p>\n"
                    );
                } else if (reminderType == 3) {
                    return (
                        "<p>Madame, Monsieur,</p>\n" +
                        "<p>Je me permets de revenir une fois de plus vers vous concernant la facture:</p>\n" +
                        defaultMailerOPList(listDocuments) +
                        "<p>En dépit de nos nombreuses relances, nous n'avons, à ce jour, toujours pas reçu votre paiement.</p>\n" +
                        "<p>Par conséquent, nous vous prions formellement de bien vouloir procéder à son règlement, et ce de manière immédiate.</p>\n" +
                        "<p>En cas de non-paiement immédiat, nous serons contraints de transmettre votre dossier à notre avocat et de recouvrer les montants par voie judiciaire.</p>\n" +
                        "<p>A titre informatif, et ce conformément aux Condition Générales de Vente, le montant des factures réclamé pourra être majoré des clauses pénales, des intérêts et éventuellement des frais de procédure.</p>\n" +
                        "<p>Merci de régler par virement bancaire sur le RIB figurant sur la facture.</p>\n" +
                        "<p>Dans l'intérêt de tous, nous espérons que vous règlerez cette affaire au plus vite.</p>\n" +
                        "<p>Nous restons à votre disposition pour tout complément d’information, et vous prions d’agréer l’expression de nos salutations distinguées.</p>\n"
                    );
                }
            }
        } else {
            return (
                "<p>Madame, Monsieur,</p>\n" +
                "<p>Après vérification de votre compte client, sauf erreur de notre part, nous n'avons pas reçu le règlement des factures suivantes :</p>" +
                defaultMailerOPList(listDocuments) +
                "<p>Pour un montant total de <strong>" +
                formatCurrency(totalBalance) +
                "</strong>." +
                // '<p></p>' +
                defaultPaymentText(displayBudgetInsightURL) +
                "<p>Nous restons à votre disposition pour tout complément d’information, et vous prions d’agréer l’expression de nos salutations distinguées.</p>" +
                "\n"
            );
        }
    } else {
        return (
            "<p>Madame, Monsieur,</p>" +
            "<p>Nous avons conscience de ne pas encore vous avoir réglé les factures suivantes :</p>" +
            defaultMailerOPList(listDocuments) +
            "Nous regrettons de n'avoir pu respecter cette échéance, et nous vous serions reconnaissant de nous accorder exceptionnellement un délai supplémentaire d'un mois, jusqu'au " +
            moment().add(1, "M").format("DD/MM/YYYY") +
            "<p>Espérant que vous voudrez bien répondre favorablement à notre demande, nous vous remercions d’avance de votre compréhension.</p>" +
            "<p>Nous vous prions de croire en l’expression de nos meilleures salutations.</p>" +
            "\n"
        );
    }
}

function documentMailType(toClients, reminder) {
    if (reminder) {
        if (toClients) {
            return "DUN_REQUEST";
        }
        return "DEFFERED_PAYMENT_REQUEST";
    }
    return "OUTSTANDING";
}

function defaultMailerOPList(listDocuments) {
    let result = "";
    for (const doc of listDocuments) {
        if (doc.invoiceNumber) {
            result +=
                "<p>  - " +
                doc.invoiceNumber +
                " d'un " +
                textForAmount(doc.personalisedAmountSigned, doc.debit, doc.credit) +
                formatDate(doc.dueDate, true) +
                "</p>";
        } else {
            result +=
                "<p>  - " +
                doc.wording +
                " d'un " +
                textForAmount(doc.personalisedAmountSigned, doc.debit, doc.credit) +
                formatDate(doc.dueDate, true) +
                "</p>";
        }
    }
    return result;
}

function defaultPaymentText(withBudgetInsightURL = false) {
    if (withBudgetInsightURL) {
        return '<p>Merci de régler cette facture directement depuis <a href="{URLDEPAIEMENT}">ce lien</a>. </p>';
    } else {
        return (
            "<p>S’il s’agit d’un simple oubli, nous vous prions de bien vouloir régulariser cette situation et de nous confirmer la date de règlement.</p>" +
            "<p>Merci de régler par virement bancaire sur le RIB figurant sur la facture.</p>"
        );
    }
}

//*  --- invoice ---

function formatInvoiceBaseFieldName(type, depositOfId) {
    switch (type) {
        case "QUOTATION":
            return "quote";
        case "CREDIT_NOTE":
            return "creditNote";
        case "BILL_DELIVERY":
            return "deliveryBill";
        default:
            if (depositOfId != null) {
                return "deposit";
            } else {
                return "invoice";
            }
    }
}

function formatInvoiceText(invoice, user, company, thirdPartyCompany, text) {
    text = text.replaceAll("$TITLE", invoice.title ? invoice.title : "");
    text = text.replaceAll("$NUMBER", invoice.number ? invoice.number : "");
    text = text.replaceAll("$PRICE", newCommonFormatCurrency(invoice.netAmount));
    text = text.replaceAll("$INVOICE_DATE", moment(invoice.date).format("DD/MM/YYYY"));
    text = text.replaceAll("$INVOICE_DUE_DATE", moment(invoice.dueDate).format("DD/MM/YYYY"));
    text = text.replaceAll("$IBAN", user?.iban ? user.iban : "");
    text = text.replaceAll("$USER_NAME", getUserDisplayName(user));
    text = text.replaceAll("$COMPANY_NAME", company.name ? company.name : "");
    text = text.replaceAll(
        "$CLIENT_COMPANY_NAME",
        thirdPartyCompany.name ? thirdPartyCompany.name : ""
    );
    text = text.replaceAll(
        "$RECEIVER_NAME",
        (invoice.receiver?.firstname ? invoice.receiver.firstname : "") +
            " " +
            (invoice.receiver?.lastname ? invoice.receiver.lastname : "")
    );
    text = text.replaceAll("\n", "</p>\n<p>");
    return text;
}

function invoiceFormatedSubject(invoice, user, thirdPartyCompany, company) {
    const baseFieldName = formatInvoiceBaseFieldName(invoice.type, invoice.depositOfId);
    return formatInvoiceText(
        invoice,
        user,
        company,
        thirdPartyCompany,
        company.invoiceData.mail[baseFieldName].header
    );
}

function invoiceFormatedText(invoice, user, thirdPartyCompany, company) {
    const baseFieldName = formatInvoiceBaseFieldName(invoice.type, invoice.depositOfId);
    let body =
        "<p>" +
        formatInvoiceText(
            invoice,
            user,
            company,
            thirdPartyCompany,
            company.invoiceData.mail[baseFieldName].body
        ) +
        "</p>";
    let signature =
        "<p>" +
        formatInvoiceText(
            invoice,
            user,
            company,
            thirdPartyCompany,
            company.invoiceData.mail.signature
        ) +
        "</p>";
    return body + "\n" + signature;
}

function invoiceDefaultSubject(invoice) {
    return "Votre " + invoice.number + (invoice.title ? ", " + invoice.title : "");
}

function invoiceDefaultText(invoice) {
    if (
        invoice.data?.receivers?.length &&
        invoice.data.receivers[0].firstname &&
        invoice.data.receivers[0].lastname
    ) {
        return (
            "<p>Bonjour " +
            invoice.data.receivers[0].firstname +
            " " +
            invoice.data.receivers[0].lastname +
            ",</p>\n" +
            "<p>Veuillez trouver ci-joint " +
            genreDeLArticle(invoice.type) +
            invoice.number +
            addIfTitle(invoice) +
            "</p>" +
            "<p><br> Bien cordialement,</p>\n"
        );
    }
    return (
        "<p>Bonjour,</p>\n" +
        "<p>Veuillez trouver ci-joint " +
        genreDeLArticle(invoice.type) +
        invoice.number +
        addIfTitle(invoice) +
        "</p>" +
        "<p><br> Bien cordialement,</p>\n"
    );
}

function textForAmount(personalisedAmountSigned, debit, credit) {
    if (personalisedAmountSigned !== debit - credit) {
        return (
            " montant initial de " +
            formatCurrency(Math.abs(debit - credit)) +
            " (avec un reste à payer de " +
            formatCurrency(Math.abs(personalisedAmountSigned)) +
            ")"
        );
    } else {
        return " montant de " + formatCurrency(Math.abs(personalisedAmountSigned));
    }
}

function formatDate(date, past = false) {
    if (!date) return "";
    moment.locale("fr");
    const verb = past ? "était" : "est";
    return " dont l'échéance " + verb + " fixée au " + moment(date).format("DD/MM/YYYY");
}

function genreDeLArticle(invoiceType) {
    if (invoiceType === "INVOICE") {
        return "la "; // la facture
    } else if (invoiceType === "CREDIT_NOTE") {
        return "l'"; // l'avoir
    } else if (invoiceType === "QUOTATION" || invoiceType === "BILL_DELIVERY") {
        return "le "; // le devis | le BL
    } else {
        debugger; // git-ignore
    }
}

function addIfTitle(invoice) {
    if (invoice.title) {
        if (invoice.type === "INVOICE") {
            return ', intitulée "' + invoice.title + '"';
        } else if (["CREDIT_NOTE", "QUOTATION", "BILL_DELIVERY"].includes(invoice.type)) {
            return ', intitulé "' + invoice.title + '"';
        }
    }
    return "";
}

function defaultTextForInvoiceType(
    invoiceType,
    avecDeterminant = false,
    grossAmountGreaterThanZero = true
) {
    if (invoiceType === "INVOICE") {
        return avecDeterminant ? "la facture" : "facture";
        // if (grossAmountGreaterThanZero) {
        //     return "Facture"
        // } else {
        //     return "Avoir"
        // }
    } else if (invoiceType === "CREDIT_NOTE") {
        return avecDeterminant ? "l'avoir" : "avoir";
    } else if (invoiceType === "QUOTATION") {
        return avecDeterminant ? "le devis" : "devis";
    } else if (invoiceType === "BILL_DELIVERY") {
        return avecDeterminant ? "le bordereau de livraison" : "bordereau de livraison";
    } else {
        debugger;
    }
}
